import ProtectedRouter from "@/context/auth/ProtectedRouter";
import NotFoundPage from "@/pages/NotFoundPage";
import routes from "@/utils/routes";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import FinEaseHomeApp from "./projects/FinEaseHome/app";
import NpsUserApp from "./projects/NPS/NpsUser/app";
import IPOApp from "./projects/IPO/app";

function App() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);
  return <AppRouterWrapper />;
}

const AppRouterWrapper = () => {
  return (
    <BrowserRouter>
      <AppWithRouter />
    </BrowserRouter>
  );
};

const AppWithRouter = () => {
  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];
  const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];

  return (
    <Routes>
      <Route element={<TopLevelComponent />}>
        <Route element={<FinEaseHomeApp />} path="/*" />

        {publicRoutes.map(({ path, element: Page }) => (
          <Route key={path} path={path} element={<Page />} />
        ))}

        <Route element={<NpsUserApp />} path="/nps-user/*" />
        <Route element={<IPOApp />} path="/ipo/*" />

        <Route element={<ProtectedRouter />}>
          {authRoutes.map(({ path, element: Page }) => (
            <Route key={path} path={path} element={<Page />} />
          ))}

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
};

const TopLevelComponent = () => <Outlet />;

export default App;
